module.exports = __webpack_public_path__ + "2490118b68e114665749524fc72620a4.MP3";